/**
 * ShutterKART copy strings, accessed via t() helper.
 * Centralised so we can wire i18next later without rewriting components.
 */
const STRINGS = {
  // brand
  "brand.name": "ShutterKART",
  "brand.tagline": "Heirloom photography for life's moments.",
  "brand.support": "ShutterKART Support",

  // nav
  "nav.home": "Home",
  "nav.services": "Services",
  "nav.portfolio": "Portfolio",
  "nav.plan": "Plan a Shoot",
  "nav.help": "Help",
  "nav.admin": "Admin",
  "nav.search": "Search",
  "nav.menu": "Menu",
  "nav.close": "Close",

  // bottom nav (mobile)
  "bottomnav.home": "Home",
  "bottomnav.explore": "Explore",
  "bottomnav.plan": "Plan",
  "bottomnav.track": "Track",

  // resume bar
  "resume.title": "You have a draft in progress",
  "resume.cta": "Resume",
  "resume.dismiss": "Dismiss",

  // home
  "home.hero.eyebrow": "Curated photography & cinematography",
  "home.services.title": "What we shoot",
  "home.services.subtitle":
    "Three doors into the ShutterKART network. Pick what fits your moment.",
  "home.packages.title": "Signature packages",
  "home.packages.subtitle":
    "Hand-picked combinations. Every quote is custom-tailored from here.",
  "home.portfolio.title": "Recent work",
  "home.portfolio.subtitle": "A small window into the gallery.",
  "home.testimonials.title": "What our clients say",
  "home.cta.title": "Plan your shoot in 4 minutes",
  "home.cta.subtitle":
    "Tell us what you need. Our team responds within 24 business hours.",
  "home.cta.button": "Get a custom quote",
  "home.viewAll.services": "View all services",
  "home.viewAll.packages": "Browse all packages",
  "home.viewAll.portfolio": "Open gallery",

  // services list
  "servicesList.title": "Our services",
  "servicesList.subtitle":
    "From mandap to milestone — a calm, full-service production for every kind of event.",

  // service detail
  "serviceDetail.subcategories": "Sub-categories",
  "serviceDetail.packages": "Packages in this service",
  "serviceDetail.faqs": "Frequently asked questions",
  "serviceDetail.cta.title": "Plan a shoot like this",
  "serviceDetail.cta.subtitle":
    "Share your event details — we'll craft a custom quote.",
  "serviceDetail.cta.button": "Start your brief",

  // package detail
  "packageDetail.startingAt": "Starting at",
  "packageDetail.disclaimer": "Final pricing tailored to your event.",
  "packageDetail.includes": "What's included",
  "packageDetail.notIncluded": "What's not included",
  "packageDetail.related": "Related packages",
  "packageDetail.cta": "Plan a custom shoot like this",
  "packageDetail.duration": "Coverage hours",
  "packageDetail.inclusions": "Inclusions",
  "packageDetail.deliverables": "Deliverables",
  "packageDetail.notIncluded.default": [
    "Travel beyond the agreed city (added transparently in quote)",
    "Premium album upgrades unless listed above",
    "Drone coverage unless listed above",
  ],

  // faqs
  "faqs.title": "Frequently asked questions",
  "faqs.subtitle":
    "Answers to the most common questions. Still curious? Drop us a line from the help page.",
  "faqs.searchPlaceholder": "Search questions…",
  "faqs.empty": "No matching questions. Try a different keyword.",

  // help
  "help.title": "Help center",
  "help.subtitle":
    "Everything you need to know to plan, request, and accept your ShutterKART quote.",
  "help.contact.title": "Need a human?",
  "help.contact.subtitle":
    "Our concierge team replies within 24 business hours.",
  "help.contact.email": "hello@shutterkart.com",
  "help.contact.phone": "+91 80 0000 0000",

  // search
  "search.placeholder": "Search services, packages, or moments…",
  "search.heading": "What are you searching for?",
  "search.emptyTitle": "Nothing matches that search",
  "search.emptySubtitle":
    "Try 'wedding', 'maternity', or plan a custom shoot below.",
  "search.emptyCta": "Plan a custom shoot",
  "search.groups.services": "Services",
  "search.groups.packages": "Packages",
  "search.groups.portfolio": "Portfolio",

  // plan placeholder
  "plan.title": "Plan a Shoot",
  "plan.subtitle":
    "The full quote builder lands in the next phase. We'll capture your occasion, dates, locations and references — and respond within 24 hours.",
  "plan.coming": "Coming next phase",
  "plan.preview":
    "What you'll do here: pick an occasion, answer 4-8 short questions, attach inspiration images, and get an instant price-range estimate before submitting.",

  // track placeholder
  "track.title": "Track your quote",
  "track.subtitle":
    "Once submitted, every quote and reply lives here — accept, decline, or ask for a revision.",
  "track.coming": "Coming in Phase 3",

  // admin
  "admin.coming": "Admin coming in Phase 4",
  "admin.subtitle":
    "The operations console for ShutterKART will land in Phase 4. Until then, please use the API directly.",

  // 404
  "notfound.eyebrow": "404",
  "notfound.title": "We couldn't find that page",
  "notfound.subtitle":
    "The link may be from an old draft or a different planet. Let's get you home.",
  "notfound.cta": "Go home",

  // generic
  "generic.loading": "Loading…",
  "generic.error":
    "Something went wrong loading this. Please retry in a moment.",
  "generic.retry": "Retry",
  "generic.empty": "Nothing here yet.",
  "generic.viewMore": "View more",

  // footer
  "footer.copy": "© 2026 ShutterKART. Heirloom photography for every moment.",
  "footer.col.services": "Services",
  "footer.col.help": "Help",
  "footer.col.legal": "Legal",
  "footer.col.contact": "Contact",
  "footer.legal.terms": "Terms of Service",
  "footer.legal.privacy": "Privacy Policy",
  "footer.legal.refund": "Refund Policy",
  "footer.legal.about": "About ShutterKART",
};

export function t(key) {
  return STRINGS[key] ?? key;
}
